import request from '@/utils/request'

export const getRoles = (org_id) =>
  request({
    url: `/page/edu_role_page?org_id=${org_id}`,
    method: 'get'
  })

export const createRole = (data: any) =>
  request({
    url: '/edu/role',
    method: 'post',
    data
  })

export const updateRole = (data: any) =>
  request({
    url: `/edu/role`,
    method: 'put',
    data
  })

export const deleteRole = (id: string) =>
  request({
    url: `edu/role?role_id=${id}`,
    method: 'delete'
  })

export const getRoutes = (params: any) =>
  request({
    url: '/routes',
    method: 'get',
    params
  })
